import {
  ConfirmModalBody,
  ConfirmModalAction,
} from 'components/Custom/ConfirmModal';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { turnModalOff } from 'store/app/actions';

interface ConfirmBoxContainerProps {
  callback: (props?: any) => void;
  callback2?: (props?: any) => void;
  param?: any;
  param2?: any;
  description: any;
  cancelText?: string;
  cancelCallback?: () => void;
  okText?: string;
  okText2?: string;
  showCancelBtn?: boolean;
}

export const ConfirmBoxContainer: React.FC<ConfirmBoxContainerProps> = ({
  callback,
  callback2,
  param,
  param2,
  description,
  cancelText,
  cancelCallback,
  showCancelBtn = true,
  okText,
  okText2,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const closeAndRun = (fn: (props?: any) => void, value?: any) => {
    dispatch(turnModalOff());
    value !== undefined ? fn(value) : fn();
  };

  const cancelAction: ConfirmModalAction | undefined = showCancelBtn
    ? {
        label: cancelText ?? t('common.cancel'),
        onClick: () => {
          cancelCallback?.();
          dispatch(turnModalOff());
        },
      }
    : undefined;

  const secondaryAction: ConfirmModalAction | undefined = callback2
    ? {
        label: okText ?? t('common.yes'),
        onClick: () => closeAndRun(callback, param),
        variant: 'default',
      }
    : undefined;

  const primaryAction: ConfirmModalAction = callback2
    ? {
        label: okText2 ?? 'Yes 2',
        onClick: () => closeAndRun(callback2, param2),
        variant: 'primary',
      }
    : {
        label: okText ?? t('common.yes'),
        onClick: () => closeAndRun(callback, param),
        variant: 'primary',
      };

  return (
    <ConfirmModalBody
      description={description}
      size="standard"
      cancelAction={cancelAction}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      showCancel={showCancelBtn}
    />
  );
};
